<template>
  <div class="wrapper">
    <h4>{{ label }}</h4>
    <p>{{ value }}</p>
  </div>
</template>

<style scoped>
  .wrapper > h4 {
    display: block;
    margin: 0;
    font-style: normal;
    font-weight: 600;
    color: var(--secondary-text-color);
  }

  .wrapper > p {
    box-sizing: border-box;
    margin: 5px 0 20px 0;
    font-size: 1.3rem;
  }
</style>

<script>
  export default {
    props: [
      'label',
      'value'
    ]
  }
</script>
